var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentVeryDissatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 22.4997C16.1163 22.4997 12.8163 24.933 11.483 28.333H28.5163C27.183 24.933 23.883 22.4997 19.9997 22.4997ZM19.983 3.33301C10.783 3.33301 3.33301 10.783 3.33301 19.9997C3.33301 29.2163 10.783 36.6663 19.983 36.6663C29.183 36.6663 36.6663 29.2163 36.6663 19.9997C36.6663 10.783 29.1997 3.33301 19.983 3.33301ZM19.9997 33.333C12.633 33.333 6.66634 27.3663 6.66634 19.9997C6.66634 12.633 12.633 6.66634 19.9997 6.66634C27.3663 6.66634 33.333 12.633 33.333 19.9997C33.333 27.3663 27.3663 33.333 19.9997 33.333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 16.4667L16.5667 14.7L14.8001 16.4667L13.0334 14.7L11.2667 16.4667L14.8001 20L18.3334 16.4667ZM25.2001 16.4667L23.4334 14.7L21.6667 16.4667L25.2001 20L28.7334 16.4667L26.9667 14.7L25.2001 16.4667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentVeryDissatisfied);
export default __webpack_public_path__ + "static/media/sentiment_very_dissatisfied.4de0a2608f79cecdeb28a8a3fa8cd204.svg";
export { ForwardRef as ReactComponent };